import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { Fragment } from "react";
import "./style/App.css";
import "./style/geomedellin.css";
import "./style/responsive.css";
import "react-datepicker/dist/react-datepicker.css";
import Home from "./components/view/Home";
import { GlobalProvider } from "./context/contextGeomedellin";
import GeoServicios from "./components/view/geoservicios/Geoservicios";
import DatosAbiertos from "./components/view/datosAbiertos/DatosAbiertos";
import Documentacion from "./components/view/documentacion/Documentacion";
import Ayudas from "./components/view/ayudas/Ayudas";
import Estadisticas from "./components/view/estadisticas/Estadisticas";
import Aplicaciones from "./components/view/aplicaciones/Aplicaciones";
import Noticias from "./components/view/noticias/Noticias";
import InfoNoticias from "./components/view/noticias/InfoNoticias";
import Grupos from "./components/view/grupos/Grupos";
import GestionGrupos from "./components/view/grupos/GestionGrupos";
import LoMasReciente from "./components/view/loMasReciente/LoMasReciente";
import ComponentGeneric from "./components/view/generic/ComponentGeneric";
import NotFound404 from "./components/common/NotFound404";
import Search from "./components/view/buscador/Search";
import PiePagina from "./components/view/piePagina/PiePagina";
import Migas from "./components/view/migasGeomedellin/Migas";
import Card from "./components/view/card/Card";
import MapaNavegacion from "./components/view/mapaNavegacion/MapaNavegacion";

import { InfoDatosAbiertos } from "./components/view/datosAbiertos/InfoDatosAbiertos";
import InfoGrupos from "./components/view/grupos/InfoGrupos";

function App({ pathData, caractFiltro }) {
  let estadisticas = pathData.filter(
    (obj) => obj.nombre_componente === "Estadísticas"
  );
  let grupos = pathData.filter((obj) => obj.nombre_componente === "Grupos");
  // console.log(estadisticas);
  return (
    // base name url padre geomedellin
    <BrowserRouter basename={`${process.env.REACT_APP_URLBASE}geomedellin`}>
      {/*contexto global envuelve a todos los componentes*/}
      <GlobalProvider>
        {/*grupo de rutas de geomdellin*/}
        <Routes>
          {/*ruta unitaria geomedellin home o ruta padre geomedellin*/}
          <Route
            path={`*`}
            element={
              <Fragment>
                <NotFound404 />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin home o ruta padre geomedellin*/}
          <Route
            path={`/`}
            element={
              <Fragment>
                <Home idComponente={0} />
                <LoMasReciente idComponente={0} caractFiltro={caractFiltro} />
                <PiePagina fluid={true} />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin geoservicios*/}
          <Route
            path={`/geoServicios`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Geoservicios"
                    ).id_componente
                  }
                />
                <GeoServicios
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Geoservicios"
                    ).id_componente
                  }
                  caractFiltro={caractFiltro}
                  fraseCorta={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Geoservicios"
                    ).fraseCorta
                  }
                  descripcion={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Geoservicios"
                    ).descripcion
                  }
                  imagen={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Geoservicios"
                    ).imagen
                  }
                />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin datos abiertos*/}

          <Route
            path={`/datosAbiertos`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).id_componente
                  }
                />
                <DatosAbiertos
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).id_componente
                  }
                  caractFiltro={caractFiltro}
                  fraseCorta={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).fraseCorta
                  }
                  descripcion={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).descripcion
                  }
                  imagen={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).imagen
                  }
                />
              </Fragment>
            }
          />

          <Route
            path={`/datosAbiertos/:id`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).id_componente
                  }
                />
                <InfoDatosAbiertos
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).id_componente
                  }
                  caractFiltro={caractFiltro}
                  descripcion={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).descripcion
                  }
                  imagen={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Datos abiertos"
                    ).imagen
                  }
                />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin noticias*/}

          <Route
            path={`/noticias`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .id_componente
                  }
                />
                <Noticias
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .id_componente
                  }
                  caractFiltro={caractFiltro}
                  fraseCorta={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .fraseCorta
                  }
                  descripcion={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .descripcion
                  }
                  imagen={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .imagen
                  }
                />
              </Fragment>
            }
          />

          <Route
            path={`/noticias/:id`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .id_componente
                  }
                />
                <InfoNoticias
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .id_componente
                  }
                  caractFiltro={caractFiltro}
                  descripcion={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .descripcion
                  }
                  imagen={
                    pathData.find((obj) => obj.nombre_componente === "Noticias")
                      .imagen
                  }
                />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin documentación*/}
          <Route
            path={`/documentacion`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Documentación"
                    ).id_componente
                  }
                />
                <Documentacion
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Documentación"
                    ).id_componente
                  }
                  caractFiltro={caractFiltro}
                  fraseCorta={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Documentación"
                    ).fraseCorta
                  }
                  descripcion={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Documentación"
                    ).descripcion
                  }
                  imagen={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Documentación"
                    ).imagen
                  }
                />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin ayudas*/}
          <Route
            path={`/ayudas`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Ayudas")
                      .id_componente
                  }
                />
                <Ayudas
                  idComponente={
                    pathData.find((obj) => obj.nombre_componente === "Ayudas")
                      .id_componente
                  }
                  caractFiltro={caractFiltro}
                  descripcion={
                    pathData.find((obj) => obj.nombre_componente === "Ayudas")
                      .descripcion
                  }
                  imagen={
                    pathData.find((obj) => obj.nombre_componente === "Ayudas")
                      .imagen
                  }
                />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin ayudas*/}
          <Route
            path={`/search`}
            element={
              <Fragment>
                <Home idComponente={1} />
                <Migas ruta={"Resultados de la búsqueda"} />
                <div className="button-search-horizontal">
                  <Search
                    position={"horizontal"}
                    element={0}
                    caractFiltro={caractFiltro}
                    style={{ top: "12%" }}
                    rr={"rr"}
                  />
                </div>
                <div className="content-result-busqueda">
                  <div className="">
                    <label class="lbl-contentdestacado ">Resultados </label>
                    <label class="lbl-contentdestacadosimple ml-5">
                      de la búsqueda
                    </label>
                    <div class="content-tematicasborder">
                      <label class="lbl-destacadosborder-b-h"></label>
                    </div>
                  </div>
                  <Card component={0} />
                </div>
                <PiePagina />
              </Fragment>
            }
          />

          {/*ruta unitaria geomedellin estadisticas*/}
          {estadisticas[0] ? (
            <Route
              path={`/estadisticas`}
              element={
                <Fragment>
                  <Home idComponente={estadisticas[0].id_componente} />
                  <Estadisticas
                    idComponente={estadisticas[0].id_componente}
                    caractFiltro={caractFiltro}
                    descripcion={estadisticas[0].descripcion}
                    imagen={estadisticas[0].imagen}
                  />
                </Fragment>
              }
            />
          ) : (
            <></>
          )}

          {/*ruta unitaria geomedellin aplicaciones*/}
          <Route
            path={`/aplicaciones`}
            element={
              <Fragment>
                <Home
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Aplicaciones"
                    ).id_componente
                  }
                />
                <Aplicaciones
                  idComponente={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Aplicaciones"
                    ).id_componente
                  }
                  fraseCorta={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Aplicaciones"
                    ).fraseCorta
                  }
                  descripcion={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Aplicaciones"
                    ).descripcion
                  }
                  caractFiltro={caractFiltro}
                  imagen={
                    pathData.find(
                      (obj) => obj.nombre_componente === "Aplicaciones"
                    ).imagen
                  }
                />
              </Fragment>
            }
          />
          {/*ruta para el modulo de grupos por id solo para el administrador */}
          {grupos[0] ? (
            <Route
              path={`/grupos/:id`}
              element={
                <Fragment>
                  <Home
                    idComponente={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .id_componente
                    }
                  />
                  <InfoGrupos
                    idComponente={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .id_componente
                    }
                    caractFiltro={caractFiltro}
                    descripcion={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .descripcion
                    }
                    imagen={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .imagen
                    }
                  />
                </Fragment>
              }
            />
          ) : (
            <></>
          )}
          {/*ruta para el modulo de grupos*/}
          {grupos[0] ? (
            <Route
              path={`/grupos`}
              element={
                <Fragment>
                  <Home
                    idComponente={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .id_componente
                    }
                  />
                  <Grupos
                    idComponente={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .id_componente
                    }
                    caractFiltro={caractFiltro}
                    fraseCorta={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .fraseCorta
                    }
                    descripcion={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .descripcion
                    }
                    imagen={
                      pathData.find((obj) => obj.nombre_componente === "Grupos")
                        .imagen
                    }
                  />
                </Fragment>
              }
            />
          ) : (
            <></>
          )}

          {/*ruta unitaria geomedellin mapa del sitio*/}
          <Route
            path={`/mapaNavegacion`}
            element={
              <Fragment>
                <Home idComponente={1} />
                <MapaNavegacion />
              </Fragment>
            }
          />

          {/* Rutas genericas de los nuevos componentes */}
          {pathData.length >= 5
            ? pathData.map((e, i) => {
                return (
                  <Route
                    key={`route-${e.url}-${i}`}
                    path={`${e.url}`}
                    element={
                      <Fragment key={e.id_componente}>
                        <Home idComponente={e.id_componente} />
                        <ComponentGeneric
                          idComponente={e.id_componente}
                          infoComponent={pathData}
                          caractFiltro={caractFiltro}
                        />
                      </Fragment>
                    }
                  />
                );
              })
            : ""}
          {/*ruta unitaria geomedellin grupos*/}
        </Routes>
      </GlobalProvider>
    </BrowserRouter>
  );
}

export default App;
